export function between(x: number, min: number, max: number) {
  return Math.max(Math.min(x, max), min)
}
